module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/microscope.ef1820d6.svg";